/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const missingKidError = "missing_kid_error";
export const missingAlgError = "missing_alg_error";
